import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const isValidPage = (value: number): boolean =>
  Number.isInteger(value) && value > 0;

export const useScreenerPageSync = (): {
  page: number;
  setPage: (page: number) => void;
} => {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageParam = searchParams.get('page');
  const parsedFromUrl = pageParam ? Number(pageParam) : NaN;
  const page =
    !Number.isNaN(parsedFromUrl) && isValidPage(parsedFromUrl)
      ? parsedFromUrl
      : 1;

  useEffect(() => {
    if (!pageParam) {
      return;
    }

    if (Number.isNaN(parsedFromUrl) || !isValidPage(parsedFromUrl)) {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete('page');
      setSearchParams(nextParams, { replace: true });
    }
  }, [pageParam, parsedFromUrl, searchParams, setSearchParams]);

  const setPage = (nextPage: number) => {
    const nextParams = new URLSearchParams(searchParams);
    if (isValidPage(nextPage)) {
      nextParams.set('page', String(nextPage));
    } else {
      nextParams.delete('page');
    }
    setSearchParams(nextParams, { replace: true });
  };

  return { page, setPage };
};
